export default class ToggleElement {
  constructor() {
    this.$checkboxElement = document.querySelectorAll('.js-checkbox-toggle-element');
    this.$radioElement = document.querySelectorAll('.js-radio-toggle-element');
    this.$flightElement = document.querySelectorAll('.js-flight-type');
    this.$flightDeparture = document.querySelector('.js-flight-departure');
    this.$flightReturn = document.querySelector('.js-flight-return');
    this.$busElement = document.querySelectorAll('.js-bus-type');
    this.$busDeparture = document.querySelector('.js-bus-departure');
    this.$busReturn = document.querySelector('.js-bus-return');
    this.$reservationWrapper = document.querySelector('.js-reservation-summary-wrapper');
    this.$reservationToggle = document.querySelector('.js-reservation-toggle');
    
    this.init();
  }

  init() {
    if (this.$checkboxElement) {
      this.$checkboxElement.forEach((element) => {
        this.toggleCheckboxElement(element);
      });
    }

    if (this.$radioElement) {
      this.$radioElement.forEach((element) => {
        this.toggleRadioElement(element);
      });
    }

    if (this.$flightElement) {
      this.$flightElement.forEach((element) => {
        this.toggleFlightType(element);
      });
    }

    if (this.$busElement) {
      this.$busElement.forEach((element) => {
        this.toggleBusType(element);
      });
    }

    if (this.$reservationToggle) {
      this.toggleReservationWrapper();
    }
  }

  toggleRadioElement(element) {
    const $targetElement = document.querySelectorAll(element.dataset.target);
    const $targetType = element.value;

    element.addEventListener('change', () => {
      $targetElement.forEach((target) => {
        target.classList.add('d-none');

        if (target.dataset.billingtype === $targetType) {
          target.classList.remove('d-none');
        }
      });
    });
  }

  toggleCheckboxElement(element) {
    const $toggleElement = document.querySelector(element.dataset.target);

    element.addEventListener('change', () => {
      if (element.checked) {
        $toggleElement.classList.remove('d-none');
      } else {
        $toggleElement.classList.add('d-none');
      }
    });
  }

  toggleFlightType(element) {
    element.addEventListener('change', () => {
      const $flightType = element.dataset.value;

      if ($flightType === 'ucus_donus') {
        this.$flightReturn.classList.remove('d-none');
        this.$flightDeparture.classList.add('d-none');
      } else if ($flightType === 'ucus_gidis') {
        this.$flightDeparture.classList.remove('d-none');
        this.$flightReturn.classList.add('d-none');
      } else {
        this.$flightDeparture.classList.remove('d-none');
        this.$flightReturn.classList.remove('d-none');
      }
    });
  }

  toggleBusType(element) {
    element.addEventListener('change', () => {
      const $busType = element.dataset.value;

      if ($busType === 'otobus_donus') {
        this.$busReturn.classList.remove('d-none');
        this.$busDeparture.classList.add('d-none');
      } else if ($busType === 'otobus_gidis') {
        this.$busDeparture.classList.remove('d-none');
        this.$busReturn.classList.add('d-none');
      } else {
        this.$busDeparture.classList.remove('d-none');
        this.$busReturn.classList.remove('d-none');
      }
    });
  }

  toggleReservationWrapper() {
    this.$reservationToggle.addEventListener('click', (e) => {
      const $target = e.currentTarget;
      const status = $target.dataset.active;

      if (status === 'false') {
        $target.dataset.active = 'true';
        this.$reservationWrapper.classList.remove('d-none');
        $target.querySelector('.js-icon').classList.replace('icon-icon_plus','icon-icon_minus');
      } else {
        $target.dataset.active = 'false';
        this.$reservationWrapper.classList.add('d-none');
        $target.querySelector('.js-icon').classList.replace('icon-icon_minus', 'icon-icon_plus');
      }
    });
  }

}


/** WEBPACK FOOTER **
 ** ./assets/js/modules/toggleElement.js
 **/